export default class extends Controller {
  static targets = ['startDateField', 'dayField', 'hiddenDayField'];

  connect() {
    this.updateRepeatOptions();
  }

  updateRepeatOptions() {
    this.defaultField = this.weekDay;
  }

  //
  // GETTERS AND SETTERS
  //

  get weekDay() {
    return moment(this.startDateFieldTarget.value).format('E') % 7;
  }

  set defaultField(val) {
    this.hiddenDayFieldTarget.value = val;
    this.dayFieldTargets.forEach(t => {
      t.disabled = t.value == val;
      t.checked  = t.value == val;
    });
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/events/campaign-brief-event-repeat-week-fields-controller.js